import React, { useEffect, useRef, useState } from "react";
import PhotoOnTopDiscover from "../../components/PhotoOnTopDiscover";
import Heading from "../../atoms/Heading";
import { styled } from "../../../stitches.config";

import usePostsForYou from "../../../helpers/usePostsForYou";

import { ExitScreenLayoutProps } from "./ExitScreenLayoutTypes";

const ExitScreenDiscoverLayout: React.FC<ExitScreenLayoutProps> = ({ posts }) => {

    const [allPosts, setAllPosts] = useState(posts);
    useEffect(() => setAllPosts(posts), [posts]);

    const wrapperRef = useRef<HTMLDivElement>(null);

    const postsForYou = usePostsForYou(10);

    useEffect(() => {
        const numberOfExtraPosts = 10 - posts.length;

        if (numberOfExtraPosts < 10) {
            const exitScreenPostsId = posts.map(p => p.OID);

            const additionalPosts = postsForYou.filter(p => !exitScreenPostsId.includes(p.OID));

            setAllPosts([
                ...posts,
                ...additionalPosts
            ].splice(0, 10));
        }

    }, [posts, postsForYou]);

    useEffect(() => wrapperRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' }));

    return (
        <Container className="container">
            <Heading title={"Zobacz również"} specialHeadingStyle="withoutDots" />
            <Wrapper ref={wrapperRef}>
                {allPosts.map(post => (
                    <>
                        <PhotoOnTopDiscover
                            article={post}
                            dataAnalyticsName={"article-from-exitScreen"}
                        />
                        <Line />
                    </>
                ))}
            </Wrapper>
        </Container>
    );

};

export default ExitScreenDiscoverLayout;

const Container = styled('div', {
    marginTop: '40px',
    color: "$grayscale100",

    "& .heading-title": {
        p: {
            margin: 0,
        }
    }
});

const Line = styled('div', {
    margin: '0 0 16px 0',
    width: "100%",
    height: "1px",
    background: "$grayscale25"
});

const Wrapper = styled('div', {
    paddingTop: "10px",
});